export class ProductCustomizationState {
    // new
    public CustomizationMethodID: number = 2;
    public allowUpload1: boolean = false;
    public allowUpload2: boolean = false;
    public ProductID: number;
    public ADA: string = '';
    public IsDefaultConfig: boolean;
    public th6Enabled: boolean;
    public ProductName_Original: string;
    public PortalID: number;
    public CDNDomain: string;
    public FramePartDomain: string;
    public JF_Width: number;
    public JF_Height: number;
    public MouldingThickness: number;
    public lino_is_dyf: boolean;
    public image_uploaded: boolean;
    public old_style_composite: string;
    public Image_Full: string;
    public BackgroundPartURL: string;

    // render settings
    public rv_moulding: number;
    public rv_mat1: number;
    public rv_mat2: number;
    public rv_document: number;
    public rv_photo: number;
    public rv_insignia: number;
    public rv_lino: number;

    // old
    public css: PCS_CSS;
    public DPI: number;
    public isHorizontal: boolean = true;
    public state_FlatImageMode: boolean = false;
    public MaxFrameWidthPx: number = 0;
    public MaxFrameHeightPx: number = 50000;
    public UseCommonDPI: boolean = false;
    public UseMaxMouldingForSizing: boolean = false;
    public Padding: number = 0;
    public debug: string;
    public FrameDisplay_width: number = 0;
    public FrameDisplay_height: number = 0;

    public Base_DocumentName: string;
    public Base_DocumentName2: string;
    public Document_Height: number = 0;
    public Document_Width: number = 0;
    public DocumentID: number = 0;
    public DocumentID2: number = 0;
    public Document2_Height: number = 0;
    public Document2_Width: number = 0;

    public BevelWidth: number = 0.0393701;
    public Base_ExtraEntityName: string;
    public Base_ExtraID: number = 0;
    public Base_ExtraHeight: number = 0;
    public Base_InsigniaID: number = 0;
    public Base_InsigniaName: string;
    public Base_InsigniaWidthInches: number = 0;
    public Base_LinoAdjustmentInches: number = 0;
    public Base_LinoID: number = 0;
    public Base_LinoName: string;
    public lino_dyf_color: string;
    public DYF_FrameStyleID: number = 0;
    public EngravedPlateID: number = 0;
    public EP_1: string;
    public EP_2: string;
    public EP_3: string;
    public EP_4: string;
    public EP_5: string;
    public EP_6: string;
    public EP_7: string;
    public EP_8: string;
    public EP_9: string;
    public EP_10: string;
    public EPBorderType: EPBorderType;
    public EPMethodID: EPMethod;
    public EPWidth: number;
    public EPHeight: number;
    public EPContent: string;
    public EngravedPlateName: string;
    public HasEngravedPlate: boolean = false;
    public ItemID: string;
    public InsigniaPosition: InsigniaPositionEnum;
    public MatCombo_IsWoodFillet: boolean = false;
    public MouldingExtWidth: number = 0;
    public MouldingName: string;
    public MouldingWidthMax: number = 2.125;
    public PrimaryMatColor: string;
    public PrimaryMatName: string;
    public PrimaryMatID: number = 0;
    public ProductTypeID: number = 0;
    public SecondaryMatColor: string;
    public SecondaryMatID: number = 0;
    public SecondaryMatName: string;
    public InnerAccentWidth: number = 0.1875;
    public VL_BG_Color: string;
    public MouldingID: number = 0;
    public IsCAF: boolean = false;
    public SelectedCategoryMapID: number = -1;
    public o1: string;
    public o2: string;
    public o3: string;
    public o4: string;
}

export interface PCS_CSS {
    frame_display_width: number;
    frame_display_height: number;

    transparentImg: string;
    pmat_BackgroundImage: string;
    pmat_width: string;
    pmat_height: string;
    pmat_backgroundSize: string;
    pmat_top: string;
    pmat_left: string;
    body_width: string;
    body_height: string;
    m_topleft_src: string;
    m_topleft_left: string;
    m_topleft_top: string;
    m_topleft_width: string;
    m_topright_src: string;
    m_topright_left: string;
    m_topright_top: string;
    m_topright_width: string;
    m_bottomright_src: string;
    m_bottomright_left: string;
    m_bottomright_top: string;
    m_bottomright_width: string;
    m_bottomleft_src: string;
    m_bottomleft_left: string;
    m_bottomleft_top: string;
    m_bottomleft_width: string;

    m_left_src: string;
    m_left_left: string;
    m_left_top: string;
    m_left_width: string;
    m_left_height: string;
    m_top_src: string;
    m_top_left: string;
    m_top_top: string;
    m_top_width: string;
    m_top_height: string;
    m_bottom_src: string;
    m_bottom_left: string;
    m_bottom_top: string;
    m_bottom_width: string;
    m_bottom_height: string;
    m_right_src: string;
    m_right_left: string;
    m_right_top: string;
    m_right_width: string;
    m_right_height: string;
    doc1_visible: boolean;
    doc1_src: string;
    doc1_left: string;
    doc1_top: string;
    doc1_width: string;
    doc1_height: string;
    doc1_pmat_bevel_backgroundColor: string;
    doc1_pmat_bevel_left: string;
    doc1_pmat_bevel_top: string;
    doc1_pmat_bevel_width: string;
    doc1_pmat_bevel_height: string;
    doc1_smat_backgroundColor: string;
    doc1_smat_left: string;
    doc1_smat_top: string;
    doc1_smat_width: string;
    doc1_smat_height: string;
    doc1_smat_bevel_backgroundColor: string;
    doc1_smat_bevel_left: string;
    doc1_smat_bevel_top: string;
    doc1_smat_bevel_width: string;
    doc1_smat_bevel_height: string;
    doc2_visible: boolean;
    doc2_src: string;
    doc2_left: string;
    doc2_top: string;
    doc2_width: string;
    doc2_height: string;
    doc2_pmat_bevel_backgroundColor: string;
    doc2_pmat_bevel_left: string;
    doc2_pmat_bevel_top: string;
    doc2_pmat_bevel_width: string;
    doc2_pmat_bevel_height: string;
    doc2_smat_backgroundColor: string;
    doc2_smat_left: string;
    doc2_smat_top: string;
    doc2_smat_width: string;
    doc2_smat_height: string;
    doc2_smat_bevel_backgroundColor: string;
    doc2_smat_bevel_left: string;
    doc2_smat_bevel_top: string;
    doc2_smat_bevel_width: string;
    doc2_smat_bevel_height: string;

    fillet_visible: boolean;
    f_container_left: string;
    f_container_top: string;
    f_container_width: string;
    f_container_height: string;
    f_topleft_src: string;
    f_topleft_left: string;
    f_topleft_top: string;
    f_topleft_width: string;
    f_topright_src: string;
    f_topright_left: string;
    f_topright_top: string;
    f_topright_width: string;
    f_bottomright_src: string;
    f_bottomright_left: string;
    f_bottomright_top: string;
    f_bottomright_width: string;
    f_bottomleft_src: string;
    f_bottomleft_left: string;
    f_bottomleft_top: string;
    f_bottomleft_width: string;
    f_left_src: string;
    f_left_left: string;
    f_left_top: string;
    f_left_width: string;
    f_left_height: string;
    f_top_src: string;
    f_top_left: string;
    f_top_top: string;
    f_top_width: string;
    f_top_height: string;
    f_bottom_src: string;
    f_bottom_left: string;
    f_bottom_top: string;
    f_bottom_width: string;
    f_bottom_height: string;
    f_right_src: string;
    f_right_left: string;
    f_right_top: string;
    f_right_width: string;
    f_right_height: string;
    insignia_visible: boolean;
    insignia_bot_visible: boolean;
    insignia_src: string;
    insignia_left: string;
    insignia_top: string;
    insignia_bot: string;
    insignia_width: string;
    insignia_height: string;
    insignia_br_visible: boolean;
    insignia_br_src: string;
    insignia_br_right: string;
    insignia_br_bot: string;
    insignia_br_width: string;
    insignia_br_height: string;

    lino_visible: boolean;
    lino_src: string;
    lino_left: string;
    lino_top: string;
    lino_width: string;
    lino_height: string;
    ep_visible: boolean;
    ep_bevel_backgroundColor: string;
    ep_bevel_left: string;
    ep_bevel_top: string;
    ep_bevel_width: string;
    ep_bevel_height: string;
    ep_pmat_backgroundImage: string;
    ep_pmat_left: string;
    ep_pmat_top: string;
    ep_pmat_width: string;
    ep_pmat_height: string;
    ep_smat_width: string;
    ep_smat_height: string;
    ep_backgroundImage: string;
    ep_backgroundSize: string;
    ep_color: string;
    ep_left: string;
    ep_top: string;
    ep_width: string;
    ep_height: string;
    ep_lines_top: string;
    ep_lines_left: string;
    ep_lines_lineHeight: string;
    ep_lines_fontSize: string;
    ep_lines_width: string;
    ep_lines_height: string;
    tassel_visible: boolean;
    tassel_src: string;
    tassel_left: string;
    tassel_top: string;
    tassel_width: string;
    tassel_height: string;
    tassel_pmat_bevel_backgroundColor: string;
    tassel_pmat_bevel_left: string;
    tassel_pmat_bevel_top: string;
    tassel_pmat_bevel_width: string;
    tassel_pmat_bevel_height: string;
    tassel_smat_backgroundColor: string;
    tassel_smat_left: string;
    tassel_smat_top: string;
    tassel_smat_width: string;
    tassel_smat_height: string;
    tassel_smat_bevel_backgroundColor: string;
    tassel_smat_bevel_left: string;
    tassel_smat_bevel_top: string;
    tassel_smat_bevel_width: string;
    tassel_smat_bevel_height: string;

    varsity_visible: boolean;
    varsity_src: string;
    varsity_left: string;
    varsity_top: string;
    varsity_width: string;
    varsity_height: string;
    varsity_pmat_bevel_backgroundColor: string;
    varsity_pmat_bevel_left: string;
    varsity_pmat_bevel_top: string;
    varsity_pmat_bevel_width: string;
    varsity_pmat_bevel_height: string;
    varsity_smat_backgroundColor: string;
    varsity_smat_left: string;
    varsity_smat_top: string;
    varsity_smat_width: string;
    varsity_smat_height: string;
    varsity_smat_bevel_backgroundColor: string;
    varsity_smat_bevel_left: string;
    varsity_smat_bevel_top: string;
    varsity_smat_bevel_width: string;
    varsity_smat_bevel_height: string;
    varsity_bg_backgroundColor: string;
    varsity_bg_left: string;
    varsity_bg_top: string;
    varsity_bg_width: string;
    varsity_bg_height: string;
    oval_visible: boolean;
    oval_src: string;
    oval_left: string;
    oval_top: string;
    oval_width: string;
    oval_height: string;
    oval_borderRadius: string;
    oval_backgroundColor: string;
    oval_pmat_bevel_backgroundColor: string;
    oval_pmat_bevel_left: string;
    oval_pmat_bevel_top: string;
    oval_pmat_bevel_width: string;
    oval_pmat_bevel_height: string;
    oval_pmat_bevel_borderRadius: string;
    oval_smat_backgroundColor: string;
    oval_smat_left: string;
    oval_smat_top: string;
    oval_smat_width: string;
    oval_smat_height: string;
    oval_smat_borderRadius: string;
    oval_smat_bevel_backgroundColor: string;
    oval_smat_bevel_left: string;
    oval_smat_bevel_top: string;
    oval_smat_bevel_width: string;
    oval_smat_bevel_height: string;
    oval_smat_bevel_borderRadius: string;
    cameo_visible: boolean;
    cameo_src: string;
    cameo_left: string;
    cameo_top: string;
    cameo_width: string;
    cameo_height: string;
    cameo_borderRadius: string;
    cameo_pmat_bevel_backgroundColor: string;
    cameo_pmat_bevel_left: string;
    cameo_pmat_bevel_top: string;
    cameo_pmat_bevel_width: string;
    cameo_pmat_bevel_height: string;
    cameo_pmat_bevel_borderRadius: string;

    spirit_visible: boolean;
    spirit_ins_bot: boolean;
    spirit_visible_lino: boolean;
    spirit_visible_ins: boolean;
    spirit_smat_bg: string;
    spi_left_left: string;
    spi_left_top: string;
    spi_left_width: string;
    spi_left_height: string;
    spi_right_right: string;
    spi_right_top: string;
    spi_right_width: string;
    spi_right_height: string;
    spi_smat_left_left: string;
    spi_smat_left_top: string;
    spi_smat_left_width: string;
    spi_smat_left_height: string;
    spi_smat_right_right: string;
    spi_smat_right_top: string;
    spi_smat_right_width: string;
    spi_smat_right_height: string;
    spi_bot1_left: string;
    spi_bot1_bot: string;
    spi_bot1_width: string;
    spi_bot1_height: string;
    spi_smat_bot1_left: string;
    spi_smat_bot1_bot: string;
    spi_smat_bot1_width: string;
    spi_smat_bot1_height: string;
    spi_bot2_right: string;
    spi_bot2_bot: string;
    spi_bot2_width: string;
    spi_bot2_height: string;
    spi_smat_bot2_right: string;
    spi_smat_bot2_bot: string;
    spi_smat_bot2_width: string;
    spi_smat_bot2_height: string;
    spi_top1_left: string;
    spi_top1_top: string;
    spi_top1_width: string;
    spi_top1_height: string;
    spi_smat_top1_left: string;
    spi_smat_top1_top: string;
    spi_smat_top1_width: string;
    spi_smat_top1_height: string;
    spi_top2_right: string;
    spi_top2_top: string;
    spi_top2_width: string;
    spi_top2_height: string;
    spi_smat_top2_right: string;
    spi_smat_top2_top: string;
    spi_smat_top2_width: string;
    spi_smat_top2_height: string;

    moulding_width: number;
    moulding_half: number;

    double_stack_width: number;
    double_stack_height: number;
    double_stack_aspect_ratio: number;
    double_stack_is_vertical: boolean;
}

export enum EPBorderType {
    Overlay = 1,
    Inset = 2,
    InnerAccent = 3,
}

export enum EPMethod {
    Old = 1,
    Extended = 2,
    Custom = 3,
    SingleDoc = 4,
}

export enum InsigniaPositionEnum {
    Top = 1,
    Bottom = 2,
}

export enum EngravedPlateStatusEnum {
    None = 0,
    Required_Gold = 1,
    Required_Silver = 2,
    Optional_Gold = 3,
    Optional_Silver = 4,
    Optional_Both = 5,
    Required_Black = 6,
    Optional_Black = 7,
}
export enum DYF_FrameStylesEnum {
    None = 0,
    Single_Document = 1,
    Double_Document = 2,
    Tassel = 3,
    Varsity = 4,
    Sports_Oval = 5,
    Portrait_Oval = 6,
    Campus_Scene = 7,
    Cameo = 8,
    Spirit = 9,
    Photo_Frame = 10,
    Century = 11,
    SpiritB = 12,
    DoubleStack = 13,
}

export const DocStackingSizeTiers: DocStackingSizeTiersClass[] = [
    {
        DocSizeTierID: 1,
        CameoRail: 2.875,
        DocDistance: 0.0,
        DocHeight: 5.0,
        DocWidth: 7.0,
        DocOverlap: 0.375,
        OvalRailSide: 2.25,
        OvalRailOvalTop: 1.75,
        OvalRailDocTop: 1.75,
        SpiritRailTopAndSides: 2.75,
        SpiritRailBottom: 3.25,
        StandardRail: 1.625,
        TasselRailHeight: 3.625,
        TasselRailWidth: 2.5,
        TasselGap: 1.625,
        TasselHeight: 9.75,
        TasselWidth: 1.625,
    },
    {
        DocSizeTierID: 2,
        CameoRail: 2.875,
        DocDistance: 0.0,
        DocHeight: 6.0,
        DocWidth: 8.0,
        DocOverlap: 0.1875,
        OvalRailSide: 2.5,
        OvalRailOvalTop: 2.25,
        OvalRailDocTop: 2.625,
        SpiritRailTopAndSides: 2.75,
        SpiritRailBottom: 3.25,
        StandardRail: 2.625,
        TasselRailHeight: 3.625,
        TasselRailWidth: 2.5,
        TasselGap: 1.625,
        TasselHeight: 9.75,
        TasselWidth: 1.625,
    },
    {
        DocSizeTierID: 3,
        CameoRail: 2.875,
        DocDistance: 0.0,
        DocHeight: 7.0,
        DocWidth: 9.0,
        DocOverlap: 0.1875,
        OvalRailSide: 2.5,
        OvalRailOvalTop: 2.25,
        OvalRailDocTop: 2.625,
        SpiritRailTopAndSides: 2.75,
        SpiritRailBottom: 3.25,
        StandardRail: 2.625,
        TasselRailHeight: 3.125,
        TasselRailWidth: 2.625,
        TasselGap: 1.375,
        TasselHeight: 9.75,
        TasselWidth: 1.625,
    },
    {
        DocSizeTierID: 4,
        CameoRail: 3.125,
        DocDistance: 0.0,
        DocHeight: 8.0,
        DocWidth: 10.0,
        DocOverlap: 0.1875,
        OvalRailSide: 2.75,
        OvalRailOvalTop: 3.25,
        OvalRailDocTop: 2.625,
        SpiritRailTopAndSides: 2.75,
        SpiritRailBottom: 3.25,
        StandardRail: 2.625,
        TasselRailHeight: 2.875,
        TasselRailWidth: 2.625,
        TasselGap: 1.375,
        TasselHeight: 10.25,
        TasselWidth: 1.625,
    },
    {
        DocSizeTierID: 5,
        CameoRail: 3.1875,
        DocDistance: 0.0,
        DocHeight: 8.5,
        DocWidth: 11.0,
        DocOverlap: 0.1875,
        OvalRailSide: 2.5,
        OvalRailOvalTop: 3.75,
        OvalRailDocTop: 2.9375,
        SpiritRailTopAndSides: 2.75,
        SpiritRailBottom: 3.25,
        StandardRail: 2.6875,
        TasselRailHeight: 2.6875,
        TasselRailWidth: 2.625,
        TasselGap: 1.5,
        TasselHeight: 10.25,
        TasselWidth: 1.625,
    },
    {
        DocSizeTierID: 6,
        CameoRail: 3.1875,
        DocDistance: 0.0,
        DocHeight: 10.0,
        DocWidth: 12.0,
        DocOverlap: 0.1875,
        OvalRailSide: 2.5,
        OvalRailOvalTop: 3.75,
        OvalRailDocTop: 2.9375,
        SpiritRailTopAndSides: 2.75,
        SpiritRailBottom: 3.25,
        StandardRail: 2.6875,
        TasselRailHeight: 2.6875,
        TasselRailWidth: 2.625,
        TasselGap: 1.5,
        TasselHeight: 10.25,
        TasselWidth: 1.625,
    },
    {
        DocSizeTierID: 7,
        CameoRail: 3.3125,
        DocDistance: 0.0,
        DocHeight: 11.0,
        DocWidth: 14.0,
        DocOverlap: 0.3125,
        OvalRailSide: 2.5,
        OvalRailOvalTop: 3.75,
        OvalRailDocTop: 2.9375,
        SpiritRailTopAndSides: 3.0,
        SpiritRailBottom: 3.5,
        StandardRail: 3.063,
        TasselRailHeight: 3.063,
        TasselRailWidth: 2.6875,
        TasselGap: 1.625,
        TasselHeight: 10.5,
        TasselWidth: 1.625,
    },
    {
        DocSizeTierID: 8,
        CameoRail: 3.3125,
        DocDistance: 0.0,
        DocHeight: 12.0,
        DocWidth: 16.0,
        DocOverlap: 0.3125,
        OvalRailSide: 2.5,
        OvalRailOvalTop: 3.75,
        OvalRailDocTop: 2.9375,
        SpiritRailTopAndSides: 3.0,
        SpiritRailBottom: 3.5,
        StandardRail: 3.063,
        TasselRailHeight: 3.063,
        TasselRailWidth: 2.75,
        TasselGap: 1.5,
        TasselHeight: 11.5,
        TasselWidth: 1.625,
    },
    {
        DocSizeTierID: 9,
        CameoRail: 3.3125,
        DocDistance: 0.0,
        DocHeight: 13.0,
        DocWidth: 17.0,
        DocOverlap: 0.3125,
        OvalRailSide: 2.5,
        OvalRailOvalTop: 3.75,
        OvalRailDocTop: 2.9375,
        SpiritRailTopAndSides: 3.0,
        SpiritRailBottom: 3.5,
        StandardRail: 3.063,
        TasselRailHeight: 3.063,
        TasselRailWidth: 3.0,
        TasselGap: 1.5,
        TasselHeight: 11.5,
        TasselWidth: 1.625,
    },
    {
        DocSizeTierID: 10,
        CameoRail: 3.3125,
        DocDistance: 0.0,
        DocHeight: 14.0,
        DocWidth: 17.0,
        DocOverlap: 0.3125,
        OvalRailSide: 2.5,
        OvalRailOvalTop: 3.75,
        OvalRailDocTop: 2.9375,
        SpiritRailTopAndSides: 3.0,
        SpiritRailBottom: 3.5,
        StandardRail: 3.313,
        TasselRailHeight: 3.313,
        TasselRailWidth: 3.25,
        TasselGap: 1.5,
        TasselHeight: 11.5,
        TasselWidth: 1.625,
    },
    {
        DocSizeTierID: 11,
        CameoRail: 3.3125,
        DocDistance: 0.0,
        DocHeight: 14.0,
        DocWidth: 18.0,
        DocOverlap: 0.3125,
        OvalRailSide: 2.5,
        OvalRailOvalTop: 3.75,
        OvalRailDocTop: 2.9375,
        SpiritRailTopAndSides: 3.0,
        SpiritRailBottom: 3.5,
        StandardRail: 3.313,
        TasselRailHeight: 3.313,
        TasselRailWidth: 3.25,
        TasselGap: 1.5,
        TasselHeight: 11.5,
        TasselWidth: 1.625,
    },
    {
        DocSizeTierID: 12,
        CameoRail: 3.3125,
        DocDistance: 0.0,
        DocHeight: 16.0,
        DocWidth: 20.0,
        DocOverlap: 0.3125,
        OvalRailSide: 2.5,
        OvalRailOvalTop: 3.75,
        OvalRailDocTop: 2.9375,
        SpiritRailTopAndSides: 3.0,
        SpiritRailBottom: 3.5,
        StandardRail: 3.313,
        TasselRailHeight: 3.313,
        TasselRailWidth: 3.25,
        TasselGap: 1.5,
        TasselHeight: 11.5,
        TasselWidth: 1.625,
    },
];

export class DocStackingSizeTiersClass {
    public DocSizeTierID: number = 0;
    public CameoRail: number;
    public DocDistance: number = 0;
    public DocHeight: number = 0;
    public DocWidth: number = 0;
    public DocOverlap: number;
    public OvalRailSide: number;
    public OvalRailOvalTop: number;
    public OvalRailDocTop: number;
    public SpiritRailTopAndSides: number;
    public SpiritRailBottom: number;
    public StandardRail: number;
    public TasselRailHeight: number = 0;
    public TasselRailWidth: number = 0;
    public TasselGap: number = 0;
    public TasselHeight: number = 0;
    public TasselWidth: number = 0;
}

export class DefaultPCS {
    public static DefaultBevel: number = 0.0393701;
    public static DefaultDocument: number = 1541; // Cornell
    public static DefaultDocWidth: number = 11;
    public static DefaultDocHeight: number = 8.5;
    public static DefaultInnerAccent: number = 385; // Gold
    public static DefaultInnerAccentWidth: number = 0.1875;
    public static DefaultInsignia: number = 2638; //Cornell Gold
    public static DefaultInsigniaSize: string = `220`;
    public static DefaultInsigniaWidthMax: number = 1.625;
    public static DefaultEPWidth: number = 3; // ****----____ EP-code-change ____----****'
    public static DefaultEPHeight: number = 1; // ****----____ EP-code-change ____----****'
    public static DefaultLinoID: number = 1564; // Cornell Gold industrial
    public static DefaultLinoWidthMax: number = 13;
    public static DefaultLinoHeightMax: number = 1.837;
    public static DefaultMaxFrameWidth: number = 550;
    public static DefaultMaxFrameHeight: number = 50000;
    public static DefaultMoulding: number = 158; // Gallery
    public static DefaultMouldingWidthMax: number = 2.375;
    public static DefaultPrimarymat: number = 337; // Black
    public static DefaultProductType: number = 3;
}
